
import ContactsBlock from '@/components/TheMain/components/ContactsBlock';
import RoundedTableRAS from '@/components/TheMain/components/RoundedTableRAS';
import CoolLightBox from "vue-cool-lightbox";
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
export default {
  name: 'Ras',
  components: {
    ContactsBlock,
    RoundedTableRAS,
    CoolLightBox
  },
  data() {
    return {
      images: [
        {url: '/images/R3002_RAS.jpg'}
      ],
      imageIndex: null,
      text: '        Гены <i>KRAS, NRAS</i> и <i>BRAF</i> человека кодируют\n' +
        '        ферменты-компоненты сигнального каскада RTK-RAS-RAF-MEK, регулирующего\n' +
        '        пролиферацию и дифференцировку клеток. Мутации в «горячих точках»\n' +
        '        экзонов 2 (c.12, c.13), 3 (c.59, c.61), 4 (c.117, c.146) генов\n' +
        '        <i>NRAS</i> и <i>KRAS</i> и мутация в экзоне 15 (c.600; мутация V600)\n' +
        '        гена <i>BRAF</i> приводят к гиперактивации белков, из-за чего происходит\n' +
        '        формирование и малигнизация опухолей.\n' +
        '        <br /><br />\n' +
        '        Наиболее часто вышеперечисленные мутации встречаются при колоректальном\n' +
        '        раке, меланоме, аденокарциноме лёгких, глиобластоме и аденокарциноме\n' +
        '        поджелудочной железы с прогностической значимостью. Помимо роли в\n' +
        '        канцерогенезе описанные мутации ассоциированы с чувствительностью\n' +
        '        опухолей к терапевтическим препаратам – анти-EGFR антителам, ингибиторам\n' +
        '        MEK1, ингибиторам BRAF.',
      mutations: [
        {
          expanded: false,
          gen: 'KRAS',
          ekzon: 'ex2 c.12',
          coords: 'chr12:25245343-25245355',
          nulleoid: 'c.35G>A',
          amino: 'p.G12D',

          inside: [
            {
              nulleoid: 'c.34G>T',
              amino: 'p.G12C',
            },
            {
              nulleoid: 'c.35G>C',
              amino: 'p.G12A',
            },
            {
              nulleoid: 'c.34G>A',
              amino: 'p.G12S',
            },
            {
              nulleoid: 'c.34G>C',
              amino: 'p.G12R',
            },
            {
              nulleoid: 'c.36T>C',
              amino: 'p.G12G',
            },
            {
              nulleoid: 'c.36T>A',
              amino: 'p.G12G',
            },
            {
              nulleoid: 'c.36T>G',
              amino: 'p.G12G',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex2 c.13',
          coords: 'c.38G>A',
          nulleoid: 'c.35G>A',
          amino: 'p.G13D',

          inside: [
            {
              nulleoid: 'c.37G>T',
              amino: 'p.G13C',
            },
            {
              nulleoid: 'c.37G>A',
              amino: 'p.G13S',
            },
            {
              nulleoid: 'c.37G>C',
              amino: 'p.G13R',
            },
            {
              nulleoid: 'c.38G>C',
              amino: 'p.G13A',
            },
            {
              nulleoid: 'c.38G>T',
              amino: 'p.G13V',
            },
            {
              nulleoid: 'c.39C>A',
              amino: 'p.G13G',
            },
            {
              nulleoid: 'c.39C>T',
              amino: 'p.G13G',
            },
            {
              nulleoid: 'c.39C>G',
              amino: 'p.G13G',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex3 c.59',
          coords: 'chr12:25227339-25227351',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.176C>G',
              amino: 'p.A59G',
            },
            {
              nulleoid: 'c.35G>A',
              amino: 'p.G12D',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex3 c.61',
          coords: 'chr12:25227339-25227351',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.183A>C',
              amino: 'p.Q61H',
            },
            {
              nulleoid: 'c.182A>G',
              amino: 'p.Q61R',
            },
            {
              nulleoid: 'c.182A>T',
              amino: 'p.Q61L',
            },
            {
              nulleoid: 'c.183A>T',
              amino: 'p.Q61H',
            },
            {
              nulleoid: 'c.181C>A',
              amino: 'p.Q61K',
            },
            {
              nulleoid: 'c.182A>C',
              amino: 'p.Q61P',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex4 c.117',
          coords: 'chr12:25225705-25225721',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.351A>T',
              amino: 'p.K117N',
            },
            {
              nulleoid: 'c.351A>C',
              amino: 'p.K117N',
            },
            {
              nulleoid: 'c.349A>G',
              amino: 'p.K117E',
            },
            {
              nulleoid: 'c.350A>G',
              amino: 'p.K117R',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex4 c.146',
          coords: 'chr12:25225622-25225635',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.437C>T',
              amino: 'p.A146V',
            },
            {
              nulleoid: 'c.436G>C',
              amino: 'p.A146P',
            },
            {
              nulleoid: 'c.436G>T',
              amino: 'p.A146S',
            },
          ],
        },
        {
          expanded: false,
          gen: 'NRAS',
          ekzon: 'ex2 c.12',
          coords: 'chr1:114716119-114716131',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.35G>A',
              amino: 'p.G12D',
            },
            {
              nulleoid: 'c.34G>A',
              amino: 'p.G12S',
            },
            {
              nulleoid: 'c.34G>T',
              amino: 'p.G12C',
            },
            {
              nulleoid: 'c.35G>T',
              amino: 'p.G12V',
            },
            {
              nulleoid: 'c.35G>C',
              amino: 'p.G12A',
            },
            {
              nulleoid: 'c.34G>C',
              amino: 'p.G12R',
            },
            {
              nulleoid: 'c.36T>C',
              amino: 'p.G12G',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex2 c.13',
          coords: 'chr1:114716119-114716131',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.38G>A',
              amino: 'p.G13D',
            },
            {
              nulleoid: 'c.37G>C',
              amino: 'p.G13R',
            },
            {
              nulleoid: 'c.38G>T',
              amino: 'p.G13V',
            },
            {
              nulleoid: 'c.37G>T',
              amino: 'p.G13C',
            },
            {
              nulleoid: 'c.37G>A',
              amino: 'p.G13S',
            },
            {
              nulleoid: 'c.38G>C',
              amino: 'p.G13A',
            },
            {
              nulleoid: 'c.39T>C',
              amino: 'p.G13G',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex3 c.59',
          coords: 'chr1:114713918-114713906',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.175G>A',
              amino: 'p.A59T',
            },
            {
              nulleoid: 'c.176C>A',
              amino: 'p.A59D',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex3 c.61',
          coords: 'chr1:114713918-114713906',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.182A>G',
              amino: 'p.Q61R',
            },
            {
              nulleoid: 'c.181C>A',
              amino: 'p.Q61K',
            },
            {
              nulleoid: 'c.182A>T',
              amino: 'p.Q61L',
            },
            {
              nulleoid: 'c.183A>T',
              amino: 'p.Q61H',
            },
            {
              nulleoid: 'c.183A>C',
              amino: 'p.Q61H',
            },
            {
              nulleoid: 'c.182A>C',
              amino: 'p.Q61P',
            },
            {
              nulleoid: 'c.181C>G',
              amino: 'p.Q61E',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex4 c.117',
          coords: 'chr1:114709676-114709663',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.231G>T',
              amino: 'p.K117N',
            },
            {
              nulleoid: 'c.231A>G',
              amino: 'p.K117N',
            },
          ],
        },
        {
          expanded: false,
          gen: '',
          ekzon: 'ex4 c.146',
          coords: 'chr1:114709587-114709576',
          nulleoid: 'c.175G>A',
          amino: 'p.A59T',

          inside: [
            {
              nulleoid: 'c.436G>A',
              amino: 'p.A146T',
            },
            {
              nulleoid: 'c.437C>T',
              amino: 'p.A146V',
            },
          ],
        },
        {
          expanded: false,
          gen: 'BRAF',
          ekzon: 'ex15 c.600',
          coords: 'chr7:140753329-140753343',
          nulleoid: 'c.1799T>A',
          amino: 'p.V600E',

          inside: [
            {
              nulleoid: 'c.1798_1799GT>AA',
              amino: 'p.V600K',
            },
            {
              nulleoid: 'c.1798_1799GT>AG',
              amino: 'p.V600R',
            },
            {
              nulleoid: 'c.1799_1800TG>AA',
              amino: 'p.V600E',
            },
          ],
        },
      ],
    }
  },

  head() {
    return {
      title: 'Инсайдер FullRAS',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Наборы для скрининга мутаций в горячих точках генов BRAF, NRAS и KRAS методом мутационно-специфической ПЦР-РВ',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content:
            'Инсайдер FullRAS, R3002, Инсайдер KRAS-2, Инсайдер NRAS-3, Инсайдер BRAF, тест система KRAS, тест система NRAS, тест система BRAF, kit KRAS, kit NRAS, kit BRAF, набор KRAS, набор NRAS, набор BRAF, мутация KRAS, мутация NRAS, мутация BRAF, R3002, R3009, R3010, R3011',
        },
      ],
    }
  },
    methods: {
      expandAll() {
        this.mutations.forEach((v) => (v.expanded = true))
      },
      hideAll() {
        this.mutations.forEach((v) => (v.expanded = false))
      },
    },
}
